<template>
<div style="padding: 10px 0px;">
  <div v-for="(info, index) in buttons"
    :key="'button' + index"
    style="padding: 5px 0px;"
  >
    <button class="action-button"
      v-text="info.text"
      @click="action(info)"
    />
  </div>
</div>
</template>

<script>
import actions from '../../../generalActions/generalActions.js'

export default {
  props: {
    buttons: Array
  },
  methods: {
    action (actionObj) {
      actions.action(this, actionObj)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/ActionButtons/ActionButtons.vue